import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { uid } from 'uid';
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';
import { startPageLoading } from '../../../store/reducers/AppSlice';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface TabObject {
    label: string;
    content: () => React.ReactNode;
  }

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs({ tabsData }: { tabsData: TabObject[] }) {
  const [value, setValue] = React.useState(0);
  const dispatch = useDispatch();

  const {t} = useTranslation();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    dispatch(startPageLoading());
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="aiotrix tabs hoc" variant='scrollable'>
        {tabsData.map((tab, index) => (
            <Tab label={t(tab.label)} {...a11yProps(index)} />
          ))}

        </Tabs>
      </Box>
      {tabsData.map((tab, index) => (
        <CustomTabPanel value={value} index={index} key={`${tabsData[index].label}_${index}_tabs${uid()}`}>

          {value == index && tab.content()}
        </CustomTabPanel>
      ))}
    </Box>
  );
}